import { createSelector } from 'reselect';
import { selectMap } from './base';

const noop = () => null;

export const selectOnListingClick = createSelector(
  createSelector(selectMap, map => map.onListingClick),
  callback => callback || noop,
);

export const selectOnListingsHover = createSelector(
  createSelector(selectMap, map => map.onListingsHover),
  callback => callback || noop,
);



// WEBPACK FOOTER //
// ./src/modules/map/selectors/events.js